"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.me = exports.logout = exports.login = void 0;
var _api = require("../../../api");
var _slice = require("./slice");
const login = credentials => async dispatch => {
  try {
    dispatch(_slice.authSlice.actions.processLogin());
    const {
      data
    } = await (0, _api.authLogin)(credentials);
    dispatch(_slice.authSlice.actions.loginSuccess(data));
  } catch (error) {
    dispatch(_slice.authSlice.actions.loginFailure(error.message));
  }
};
exports.login = login;
const logout = () => async dispatch => {
  try {
    dispatch(_slice.authSlice.actions.processLogout());
    await (0, _api.authLogout)();
    (0, _api.setAuthorizationHeader)('');
    dispatch(_slice.authSlice.actions.logoutSuccess());
  } catch {
    dispatch(_slice.authSlice.actions.logoutFailure());
  }
};
exports.logout = logout;
const me = accessToken => async dispatch => {
  try {
    dispatch(_slice.authSlice.actions.processMe);
    (0, _api.setAuthorizationHeader)(accessToken);
    await (0, _api.authMe)();
    dispatch(_slice.authSlice.actions.meSuccess());
  } catch {
    dispatch(_slice.authSlice.actions.meFailure());
  }
};
exports.me = me;